import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '../../material/material.module';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule } from '@angular/forms';
import { FilteredTransactionsComponent } from './filtered-transactions/filtered-transactions.component';
import { GroupedTransactionsComponent } from './grouped-transactions/grouped-transactions.component';
import { AudienceComponent } from './audience/audience.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';

@NgModule({
  declarations: [FilteredTransactionsComponent, GroupedTransactionsComponent, AudienceComponent],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    FormsModule,
    NgxChartsModule
  ],
  exports: [
    FilteredTransactionsComponent,
    GroupedTransactionsComponent,
    AudienceComponent
  ]
})
export class ChartsModule { }
